import { httpPromise } from "./httpUtility"
//=====================================================================
function showLoadingElement(loadingElement) {
    $(function () {
        $(loadingElement).show();
    });
}
//=====================================================================
function hideLoadingElement(loadingElement) {
    $(function () {
        $(loadingElement).hide();
    });
}
//=====================================================================
export const getCart = function (component, loadingElement) {
    if (IsNullOrEmptyString(localStorage.getItem('CartHashId'))) {
        component.$store.commit('setCart', null);
    } else {
        showLoadingElement(loadingElement);
        httpPromise(component, '/v1/Orders/Carts/Read/', 'get', { HashCartId: localStorage.getItem("CartHashId") },
            response => {
                component.$store.commit('setCart', response.data.Value);
                hideLoadingElement(loadingElement);
            },
            response => {
                if (response.status == 400) {
                    if (response.data.Value != null && response.data.Value.IsCartEmpty == true) {
                        localStorage.removeItem('CartHashId');
                        component.$store.commit('setCart', null);
                    }
                    hideLoadingElement(loadingElement);
                }
            }
        );
    }
}
//=====================================================================
export const setCart = function (component, productSaleParamId, type, loadingElement, updatePaymentType = null, quantity) {

    var url = '';
    var method = ''
    switch (type) {
        case 'AddItemWithProductId':
            url = '/v1/Orders/Carts/AddItemWithProductId/';
            method = 'post'
            break;
        case 'Increase':
            url = '/v1/Orders/Carts/IncreaseCartItem/';
            method = 'post'
            break;
        case 'UpdateQuantity':
            url = '/v1/Orders/Carts/UpdateQuantity/';
            method = 'post'
            break;
        case 'Decrease':
            url = '/v1/Orders/Carts/DecreaseCartItem/';
            method = 'post'
            break;
        case 'RemoveItem':
            url = '/v1/Orders/Carts/RemoveCartItem';
            method = 'delete';
            break;
        case 'UpdatePaymentType':
            url = '/v1/Orders/Carts/UpdatePaymentType';
            method = 'post';
            break;

    };
    showLoadingElement(loadingElement);
    toastr.remove();
    var data = {
        HashCartId: localStorage.getItem("CartHashId"),
        ProductSaleParamId: productSaleParamId
    }
    if (type == 'UpdatePaymentType') {
        data.PaymentType = updatePaymentType;
        data.Quantity = quantity;
    }
    if (type == 'UpdateQuantity') {
        data.Quantity = quantity;
    }
    if (type == 'AddItemWithProductId') {
        data.Quantity = quantity;
    }
    httpPromise(component, url, method, data,
        response => {
            component.$store.commit('setCart', response.data.Value);
            localStorage.setItem("CartHashId", response.data.Value.HashCartId);
            hideLoadingElement(loadingElement);
            if (response.data.Value.CartStatusTypes == 2)
                toastr.error("سفارش درحالت پرداخت می باشد امکان تغییر وجود ندارد حداکثر زمان لازم برای ویرایش 10دقیقه می باشد.");
            else
                toastr.success("تغییرات با موفقیت به سبد خرید اعمال شد");



            if (response.data.Value.IsCartEmpty == true) {
                localStorage.removeItem('CartHashId');
                component.$store.commit('setCart', null);
            }


        },
        response => {
            if (response.status == 400) {
                toastr.error(response.data.Message);
            }
            hideLoadingElement(loadingElement);
        }
    );
}
//===================================================================== 
export const batchUpdateQuantity = function (component, loadingElement, data, runOnSuccess) {
    showLoadingElement(loadingElement);
    toastr.remove();
    httpPromise(component, '/v1/Orders/Carts/BatchUpdateQuantity/', 'post', data,
        response => {
            component.$store.commit('setCart', response.data.Value);
            localStorage.setItem("CartHashId", response.data.Value.HashCartId);
            hideLoadingElement(loadingElement);
            if (response.data.Value.CartStatusTypes == 2)
                toastr.error("سفارش درحالت پرداخت می باشد امکان تغییر وجود ندارد حداکثر زمان لازم برای ویرایش 10دقیقه می باشد.");
            else
                toastr.success("تغییرات با موفقیت به سبد خرید اعمال شد");
            if (runOnSuccess != null) {
                runOnSuccess();
            }


            if (response.data.Value.IsCartEmpty == true) {
                localStorage.removeItem('CartHashId');
                component.$store.commit('setCart', null);
            }

        },
        response => {
            if (response.status == 400) {
                toastr.error(response.data.Message);
            }
            hideLoadingElement(loadingElement);
        }
    );
}